export default "__VITE_ASSET__CYiw2PNY__"